import IconAep from "./icon-aep.svg?react";
import IconAi from "./icon-ai.svg?react";
import IconAvi from "./icon-avi.svg?react";
import IconCsv from "./icon-csv.svg?react";
import IconDoc from "./icon-doc.svg?react";
import IconDocx from "./icon-docx.svg?react";
import IconEps from "./icon-eps.svg?react";
import IconFallback from "./icon-fallback.svg?react";
import IconFig from "./icon-fig.svg?react";
import IconGif from "./icon-gif.svg?react";
import IconImg from "./icon-img.svg?react";
import IconIndd from "./icon-indd.svg?react";
import IconJpeg from "./icon-jpeg.svg?react";
import IconJpg from "./icon-jpg.svg?react";
import IconMkv from "./icon-mkv.svg?react";
import IconMov from "./icon-mov.svg?react";
import IconMp3 from "./icon-mp3.svg?react";
import IconMp4 from "./icon-mp4.svg?react";
import IconMpeg from "./icon-mpeg.svg?react";
import IconPdf from "./icon-pdf.svg?react";
import IconPng from "./icon-png.svg?react";
import IconPpt from "./icon-ppt.svg?react";
import IconPptx from "./icon-pptx.svg?react";
import IconPsd from "./icon-psd.svg?react";
import IconSvg from "./icon-svg.svg?react";
import IconTiff from "./icon-tiff.svg?react";
import IconTxt from "./icon-txt.svg?react";
import IconWav from "./icon-wav.svg?react";
import IconWebp from "./icon-webp.svg?react";
import IconXls from "./icon-xls.svg?react";
import IconXlsx from "./icon-xlsx.svg?react";

// File icons mapping
export const FILE_ICONS = {
  aep: IconAep,
  ai: IconAi,
  avi: IconAvi,
  csv: IconCsv,
  doc: IconDoc,
  docx: IconDocx,
  eps: IconEps,
  fallback: IconFallback,
  fig: IconFig,
  gif: IconGif,
  img: IconImg,
  indd: IconIndd,
  jpeg: IconJpeg,
  jpg: IconJpg,
  mkv: IconMkv,
  mov: IconMov,
  mp3: IconMp3,
  mp4: IconMp4,
  mpeg: IconMpeg,
  pdf: IconPdf,
  png: IconPng,
  ppt: IconPpt,
  pptx: IconPptx,
  psb: IconPsd,
  psd: IconPsd,
  svg: IconSvg,
  tiff: IconTiff,
  txt: IconTxt,
  wav: IconWav,
  webp: IconWebp,
  xls: IconXls,
  xlsx: IconXlsx,
} as const;
